import { http } from "../http/Http";
import { ObjectFieldDataType, ServiceResponse } from "../models";

export class ObjectFieldDataTypeService {

    getObjectFieldDataTypes = async (): Promise<ServiceResponse<ObjectFieldDataType[]>> => {
        const { data } = await http.get<ServiceResponse<ObjectFieldDataType[]>>("ObjectFieldsDataType/GetAll");
        return data;
    };

}